import { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Grid, Box, Stack, Typography } from '@mui/material';

import useScreen from 'hooks/useScreen';
import useTranslates from 'utils/translate';

import roulette from 'assets/home/roulette.png';
import turboGamesImage from 'assets/home/turboGames.png';
import tvBetImage from 'assets/home/tvGames.png';
import slotsImage from 'assets/home/slots.png';
import sportImage from 'assets/home/sport.png';

import sx from './styles';
import useWebsiteSports from 'store/websiteSports';
import { useSportQueries } from 'hooks/useSportLinks';

type ItemType = {
  path?: string;
  label?: string;
  image?: string;
};

const NavCard: FC<{
  item: ItemType;
  isMobile?: boolean;
}> = ({ item, isMobile }) => {
  const { translate } = useTranslates();

  return (
    <Link to={item.path}>
      <Box sx={sx.box({ isMobile })}>
        <Box sx={sx.image({ isMobile, image: item.image })} />
        <Box sx={sx.title({ isMobile })}>
          <Box
            component="span"
            sx={{
              ...sx.round,
              left: -10,
              '& em': {
                borderRadius: '0 0 10px 0',
              },
            }}
          >
            <Box component="em" />
          </Box>
          <Typography fontSize={isMobile ? 14 : 18} color="primary.main" fontWeight="700">
            {translate(item.label)}
          </Typography>
          <Box
            component="span"
            sx={{
              ...sx.round,
              right: -10,
              '& em': {
                borderRadius: '0 0 0 10px',
              },
            }}
          >
            <Box component="em" />
          </Box>
        </Box>
      </Box>
    </Link>
  );
};

const HomeNavigationSection = () => {
  const { isMobile } = useScreen();
  const [websiteSports] = useWebsiteSports();

  const firstSport = websiteSports.data[0];

  const { getSportQuery } = useSportQueries();

  const items: ItemType[] = useMemo(
    () => [
      {
        path: `/sport/${firstSport?.id}${getSportQuery(firstSport)}`,
        label: 'sport',
        image: sportImage,
      },
      {
        path: '/games/live_casino',
        label: 'live_casino',
        image: roulette,
      },
      {
        path: '/games/slots',
        label: 'slots',
        image: slotsImage,
      },
      {
        path: '/games/tv_games',
        label: 'tv_bet',
        image: tvBetImage,
      },
      {
        path: '/games/turbo_games',
        label: 'turbo_games',
        image: turboGamesImage,
      },
      {
        path: '/games/virtual_sport',
        label: 'virtual_sport',
        image: sportImage,
      },
    ],
    [firstSport]
  );

  if (isMobile) {
    return (
      <Stack
        mx={-2}
        direction="row"
        sx={{
          overflowX: 'auto',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {items.map((item, index) => (
          <Box key={index} px={1} minWidth="180px">
            <NavCard item={item} isMobile />
          </Box>
        ))}
      </Stack>
    );
  }

  return (
    <Grid container component="section" spacing={2} mt={1}>
      {items.map((item, index) => (
        <Grid item xs={6} md={4} lg={2} key={index}>
          <NavCard item={item} />
        </Grid>
      ))}
    </Grid>
  );
};

export default HomeNavigationSection;
